<template>
    <div class="element" :data-required="this.required" :class="{ [this.type] : true, error : error.error }">
        <labelElement v-bind="resolveProps('label', this)" :error="error" />
        <input
            type="color"
            :id="`field_${this.id}`"
            :name="this.name"
            :readonly="!this.editing || this.readonly"
            :placeholder="`${this.show_placeholder ? placeholder + (required ? ' *' : '') : ''}`"
            :autocomplete="this.autocomplete"
            :maxlength="this.maxlength"
            :aria-describedby="error.error ? `error_${this.id}` : null"
            v-model="input"
            @keyup="validate"
            @blur="validate"
            @change="handleChange"
        />
        <errorElement v-bind="resolveProps('error', this)" :error="error" :errorId="`error_${this.id}`" />
        <tooltipElement v-bind="resolveProps('tooltip', this)" :inline="true" />
    </div>
</template>

<script>
import {ref, watch, computed} from "vue";

// Our form helpers
import useFieldValidation from "formbuilder/fields/_validation";
import { propDefaults, resolveProps } from "formbuilder/fields/_props";

// Our helpers
import { mergeDeep } from "helpers/_objects";
import trans from "helpers/_translation";

import labelElement from "formbuilder/elements/LabelElement.vue";
import stateElement from "formbuilder/elements/StateElement.vue";
import placeholderElement from "formbuilder/elements/PlaceholderElement.vue";
import errorElement from "formbuilder/elements/ErrorElement.vue";
import tooltipElement from "formbuilder/elements/TooltipElement.vue";

export default {
    props: mergeDeep(
        propDefaults,
        {

        }
    ),
    components: {
        labelElement,
        stateElement,
        placeholderElement,
        errorElement,
        tooltipElement
    },
    setup(props, { emit }) {
        const input = ref("");
        const {registerValidator, validate, error} = useFieldValidation();
        registerValidator(input, props);

        watch(
            () => props.value,
            () => {
                input.value = props.value ?? props.default_value;
            },
            {
                immediate: true
            }
        );

        const handleChange = () => {
            emit('value-change', {
                name: props.name,
                value: input.value
            });
        }

        const placeholder = computed(() => props.translate ? trans(props.placeholder) : props.placeholder);

        return {
            trans,
            input,
            error,
            resolveProps,
            validate,

            handleChange,
            placeholder
        };
    },
}
</script>